<template>
  <div id="app">
<el-card  class="login-container"
>
  <el-tag>选择账户：</el-tag>
  <br>

  <el-select v-model="TokenValue" placeholder="请选择">
    <el-option
      v-for="item in options1"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
<br>
  <br>
  <el-input
    heigth="211%"
    type="textarea"
    autosize
    placeholder="输入账户id    多个换行处理"
    v-model="textarea1">
  </el-input>
  <br><br><br>

  <el-button type="primary" v-on:click="downloadImages"  :disabled="isDisable" round>下载拒审素材</el-button>

</el-card>

  </div>

</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {

  name: "batchState",

  data(){
  return {
    options1: [

      {
        value: 'c76459da2362e48013633cb91913ba3c38e1527e7ef55894836704101232321d',
        label: '企鹅',

      },  {
        value: '99ad52c9f6ffc7df551d6996d94d8717d3aaba4cd4ba7c0552744fb861709fe9',
        label: '火苗',

      },  {
        value: '07ee5b503590c45232d1ae2ea4731366d07034d78458d38ae5cbed17b2f51fbc',
        label: '胡桃',

      },  {
        value: 'ca259bad744a93d5dd1e2d832af522ed5ba4c48afe91d4329b87623970fe350a',
        label: '浙江伊看',

      },  {
        value: '860aa0e3a31f05262240fac510e10b75953f87eac68f4fb8580d59edb7c09b60',
        label: '福建伊看',

      },

    ],
    uuid:[],
    TokenValue:'',

    textarea1:'',
    imageUrls: '',
    videoUrls: '',
  }},

  methods: {
    async downloadImages() {
      this.uuid=this.textarea1.trim().split(/\n/);
   for (let key in this.uuid){
     let pams={
       token:this.TokenValue,
       adid:this.uuid[key],
     }
     await this.pageInfoByLastId(pams);

     this.videoUrls.forEach((url, index) => {
       let nonce = Math.round(Math.random() * 100000000000)

       const filename = `video_${nonce + 1}.mp4`; // 设置图片文件名，可以根据需求自定义'
       this.downloadvideo(url, filename);
     });
     setTimeout(()=>{

       this.imageUrls.forEach((url, index) => {
         let nonce2 = Math.round(Math.random() * 100000000000)

         const filename = `imagesssss_${nonce2 + 1}.jpg`; // 设置图片文件名，可以根据需求自定义
         this.downloadImage(url, filename);
       });
     },3000);
   }

    },

    async  downloadImage(url, filename) {
      this.$axios({
        url: url,
        method: 'GET',
        responseType: 'blob'
      }).then(response => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(error => {
        console.error(error);
      });
    },
    async  downloadvideo(url, filename) {
      this.$axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        timeout:10000 // 设置超时时间为 5 秒

      }).then(response => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(error => {
        console.error(error);
      });
    },
    async pageInfoByLastId(pams){
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/creative/pageInfoByLastId?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "lastId":0
        }).then(resp=>
      {
        let arr=[]
        let video=[]
          for (let key in resp.data.data.data){
          console.log(resp.data.data.data[key].auditState)
            if (resp.data.data.data[key].auditState==2){
              console.log(resp.data.data.data[key].videoUrl)
              if (resp.data.data.data[key].videoUrl!==undefined){
                arr.push("https://ads-marketing-vivofs.vivo.com.cn"+resp.data.data.data[key].imgsUrl)
                video.push("https://ads-marketing-vivofs.vivo.com.cn"+resp.data.data.data[key].videoUrl)
              }else {
                arr.push("https://ads-marketing-vivofs.vivo.com.cn"+resp.data.data.data[key].imgsUrl)
              }
            }
        }
        this.imageUrls=arr
        this.videoUrls=video
        this.imageUrls=this.imageUrls.filter((url, index) => {
          return this.imageUrls.indexOf(url) === index;
        });
        this.videoUrls=this.videoUrls.filter((url, index) => {
          return this.videoUrls.indexOf(url) === index;
        });
        console.log(this.imageUrls)
        console.log(this.videoUrls)

      })


    },
  }
}



</script>

<style scoped>
.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 90px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
</style>



// WEBPACK FOOTER //
// src/components/batchState.vue